import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Redirect } from 'react-router-dom'

import Select from 'react-select';
import moment from 'moment';

import swal from 'sweetalert';
import { Modal } from 'react-bootstrap';
import { Pagination } from 'antd';
import { Tooltip } from 'antd';

import { setCookie, getCookie } from '../common_component/cookie.js';
import { useTheme } from "./theme-provider.js";
import { useAuthData } from "./auth-provider.js";
import PageError from "../common_component/PageError.js";
import { useModal } from '../providers/modal-provider.js';

function EcommerceDeliveryPartner() {
    const [state, setstate] = useState(2);
    const { openModal, setModalView, setModalData } = useModal();
    const [deliveryPartnerList, setDeliveryPartnerList] = useState([]);
    const [deliveryPartnerListApiState, setDeliveryPartnerListApiState] = useState(false);

    const [searchValue, setSearchValue] = useState('');
    const [approveLoading, setApproveLoading] = useState(false);
    const [totalListLength, setTotalListLength] = useState(0);
    const [current_page, setCurrent_page] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [approvalModal, setApprovalModal] = useState(false);
    const [selectedPartner, setSelectedPartner] = useState(null);
    const [docModal, setDocModal] = useState(false);
    const [docData, setDocData] = useState(null);
    const [imagePreview, setImagePreview] = useState({ show: false, url: "" });

    const apiController = useRef(new AbortController())

    var page_name = "ecommerce-delivery-partners";

    const { user, read, write, visibility, organization_id } = useAuthData(page_name);

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    async function approvePartner() {
        try {
            setApproveLoading(true);
            await approveEcommerceDeliveryPartner(selectedPartner.uid, "approved");
            swal({
                title: "Partner Approved!",
                text: `${selectedPartner?.personal_info?.name} has been successfully approved.`,
                icon: "success",
                button: "OK"
            });
            setApprovalModal(false);
        } finally {
            setApproveLoading(false);
        }
    }

    async function approveEcommerceDeliveryPartner(id, status) {
        setDeliveryPartnerListApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/approve-ecommerce-delivery-partner`, { method: 'POST', body: JSON.stringify({ "email": user.email, "partner_id": id, "add_status": status, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation !== "success") throw "approve ecommerce delivery partner api error"

        await getEcommerceDeliveryPartners(current_page, pageSize, searchValue)

        setDeliveryPartnerListApiState(false)
    }

    async function getEcommerceDeliveryPartners(page_number, size, search_val) {
        try {
            if (deliveryPartnerListApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            setDeliveryPartnerListApiState(true)
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-delivery-partner-list`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "current_page": page_number - 1, "rows_per_page": size, "search_value": search_val, "page_name": page_name, "email": user.email, "flag": "collection_list", "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            if (body.operation !== "success") throw "get ecommerce coupon list api error"

            setDeliveryPartnerList(body.data.list)
            setTotalListLength(body.data.count)
            setDeliveryPartnerListApiState(false)
        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            let p1 = getEcommerceDeliveryPartners(current_page, pageSize, searchValue);

            Promise.all([p1])
                .then(() => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    console.log(err)
                })
        }
    }, [user, visibility, read, write])

    useEffect(() => {
        if (state === 1) {
            getEcommerceDeliveryPartners(current_page, pageSize, searchValue)
        }
    }, [current_page, pageSize, searchValue])

    return (
        <>
            <div>
                <div className="d-flex flex-stack mb-5">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Delivery Partners</h1>
                    {/* <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <button className='btn btn-success' onClick={(e) => { setModalShow(true); setEditModalVehicleDetails(false); setVehicleInfo({ vehicleType: null, vehicleNumber: null, vehicleFuelType: null, vehicleModel: null, manufactureYear: null }) }}><i className="las la-plus"></i>Add New</button>
                    </div> */}
                </div>
                <div>
                    {state === 1 ?
                        <>
                            <div className="card mb-5 mb-xl-8">
                                <div className="card-header border-0 pt-5">
                                    <h3 className="card-title align-items-start flex-column">
                                        <span className="card-label fw-bold fs-3 mb-1">Delivery Partner List</span>
                                        <span className="text-muted mt-1 fw-semibold fs-7">Over {deliveryPartnerList.length} Delivery Partners</span>
                                    </h3>
                                    <div className="card-toolbar">
                                        <Pagination
                                            total={totalListLength}
                                            onChange={(page, pageSize) => {
                                                setCurrent_page(page);
                                                setPageSize(pageSize);
                                            }}
                                            showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                                            defaultPageSize={pageSize}
                                            defaultCurrent={current_page}
                                            showSizeChanger={true}
                                        />
                                    </div>

                                </div>
                                <div className="card-body py-3">
                                    <div className="table-responsive" style={{
                                        minHeight: "200px"
                                    }}>
                                        <div className='m-5'>
                                            <input type="text" className='form-control fw-bold border border-primary' value={searchValue} onChange={(e) => { setSearchValue(e.target.value) }} placeholder='Search Delivery Partners...' />
                                        </div>
                                        <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                                            <thead>
                                                <tr className="fw-bold text-muted">
                                                    <th className="min-w-120px">Partner Name</th>
                                                    <th className="min-w-150px">Address Info</th>
                                                    <th className="min-w-150px">Vehicle Info</th>
                                                    <th className="min-w-150px">Bank Info</th>
                                                    <th className="min-w-150px">Files</th>
                                                    <th className="min-w-120px">Status</th>
                                                    <th className="min-w-50px text-end">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {deliveryPartnerListApiState ? (
                                                    <tr>
                                                        <td colSpan={8} className="text-center pt-10">
                                                            <div className="spinner-border text-primary"></div>
                                                        </td>
                                                    </tr>
                                                ) : deliveryPartnerList.length > 0 ? (
                                                    deliveryPartnerList.map((obj, index) => (
                                                        <tr key={index} className="align-middle">

                                                            {/* Partner Name */}
                                                            {/* Partner Name with Phone + Email inside tooltip */}
                                                            <td>
                                                                <Tooltip
                                                                    placement="top"
                                                                    title={
                                                                        <>
                                                                            <div><strong>Phone:</strong> {obj.personal_info?.phone ?? "-"}</div>
                                                                            <div><strong>Email:</strong> {obj.personal_info?.email ?? "-"}</div>
                                                                        </>
                                                                    }
                                                                >
                                                                    <span className="fw-bold fs-6 text-primary cursor-pointer">
                                                                        {obj.personal_info?.name ?? "-"}
                                                                        <i className="fas fa-info-circle ms-1"></i>
                                                                    </span>
                                                                </Tooltip>
                                                            </td>

                                                            {/* Address */}
                                                            <td>
                                                                <Tooltip
                                                                    title={
                                                                        <>
                                                                            <div>{obj.address_info?.street}</div>
                                                                            <div>{obj.address_info?.city}</div>
                                                                            <div>{obj.address_info?.state}</div>
                                                                            <div>{obj.address_info?.country}</div>
                                                                            <div>Pincode: {obj.address_info?.pincode}</div>
                                                                        </>
                                                                    }
                                                                    placement="right"
                                                                >
                                                                    <span className="text-gray-600 cursor-pointer">
                                                                        {obj.address_info?.street ?? "-"}, {obj.address_info?.city ?? "-"}
                                                                        <i className="fas fa-location-dot text-primary ms-2"></i>
                                                                    </span>
                                                                </Tooltip>
                                                            </td>

                                                            {/* Vehicle Info */}
                                                            <td>
                                                                <Tooltip
                                                                    title={
                                                                        <>
                                                                            <div>Type: {obj.vehicle_info?.type}</div>
                                                                            <div>Reg No: {obj.vehicle_info?.registration_number}</div>
                                                                        </>
                                                                    }
                                                                    placement="right"
                                                                >
                                                                    <span className="fw-bold cursor-pointer text-dark">
                                                                        {obj.vehicle_info?.type ?? "-"}
                                                                    </span>
                                                                    <br />
                                                                    <span className="badge badge-secondary">
                                                                        {obj.vehicle_info?.registration_number ?? "-"}
                                                                    </span>
                                                                    <i className="fas fa-car text-primary ms-2"></i>
                                                                </Tooltip>
                                                            </td>

                                                            {/* Bank Info */}
                                                            <td>
                                                                <Tooltip
                                                                    title={
                                                                        <>
                                                                            <div>AC: {obj.bank_kyc?.account_no}</div>
                                                                            <div>IFSC: {obj.bank_kyc?.ifsc}</div>
                                                                        </>
                                                                    }
                                                                >
                                                                    <span className="text-primary cursor-pointer small">
                                                                        <i className="fas fa-university me-1"></i>Bank Details
                                                                    </span>
                                                                </Tooltip>
                                                            </td>

                                                            {/* Uploaded Documents */}
                                                            <td>
                                                                <button
                                                                    className="btn btn-sm btn-light-primary"
                                                                    onClick={() => {
                                                                        setDocData(obj.uploaded_files);
                                                                        setDocModal(true);
                                                                    }}
                                                                >
                                                                    <i className="fas fa-folder-open me-1"></i>
                                                                    View Files
                                                                </button>
                                                            </td>


                                                            {/* Approval Stage */}
                                                            <td>
                                                                {obj.approval_stage?.stage === "approved" ? (
                                                                    <span className="badge badge-light-success">Approved</span>
                                                                ) : obj.approval_stage?.stage === "pending" ? (
                                                                    <span className="badge badge-light-warning">Pending</span>
                                                                ) : (
                                                                    <span className="badge badge-light-secondary">{obj.approval_stage?.stage}</span>
                                                                )}
                                                            </td>

                                                            {/* Actions Dropdown */}

                                                            <td className="text-end">
                                                                <div className="dropdown">
                                                                    <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"><i className="fas fa-bars px-0"></i></button>
                                                                    {
                                                                        write &&
                                                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                            {obj.approval_stage?.stage === "pending" &&
                                                                                <li className={`dropdown-item cursor-pointer`} onClick={() => {
                                                                                    setSelectedPartner(obj);
                                                                                    setApprovalModal(true);
                                                                                }}>
                                                                                    Approve Partner
                                                                                </li>
                                                                            }
                                                                            {obj.approval_stage?.stage === "approved" &&
                                                                                <li className={`dropdown-item cursor-pointer`}
                                                                                    onClick={() => {
                                                                                        setModalView("TRACKING_VIEW");
                                                                                        setModalData({ type: "partner", partner_id: obj.uid, partner_name: obj.personal_info.name });   // <-- Pass full order details
                                                                                        openModal();
                                                                                    }}>
                                                                                    Live Tracking
                                                                                </li>
                                                                            }
                                                                        </ul>
                                                                    }
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={8} className="text-center py-10">
                                                            <h3 className="text-muted">No delivery partners found</h3>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>

                                        </table>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        state === 2 ?
                            <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                            :
                            <PageError />
                    }
                </div>
                <Modal show={approvalModal} onHide={() => setApprovalModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Approve Delivery Partner</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h5>Are you sure you want to approve?</h5>
                        <p className="text-muted">
                            Partner: <strong>{selectedPartner?.personal_info?.name}</strong>
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-light" onClick={() => setApprovalModal(false)}>
                            Cancel
                        </button>
                        <button
                            className="btn btn-success"
                            onClick={approvePartner}
                            disabled={approveLoading}
                        >
                            {approveLoading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                    Approving...
                                </>
                            ) : (
                                "Approve Now"
                            )}
                        </button>
                    </Modal.Footer>
                </Modal>
                <Modal show={docModal} onHide={() => setDocModal(false)} centered size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Partner Documents</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        {docData ? (
                            <div className="row g-4">
                                {/* Main Documents */}
                                {[
                                    { key: "id_proof", title: "ID Proof" },
                                    { key: "license", title: "Driving License" },
                                    { key: "rc", title: "RC Book" },
                                    { key: "photo", title: "Photograph" },
                                ].map((item, idx) =>
                                    docData[item.key] ? (
                                        <div className="col-md-4" key={idx}>
                                            <div className="border rounded p-3 shadow-sm text-center">

                                                <h6 className="fw-bold mb-2">{item.title}</h6>

                                                {/* Show Image or PDF Icon */}
                                                {docData[item.key].original_filename.match(/\.(jpeg|jpg|png|webp)$/i) ? (
                                                    <img
                                                        src={docData[item.key].url}
                                                        alt={item.title}
                                                        className="img-fluid rounded mb-3 cursor-pointer"
                                                        style={{ maxHeight: "160px", objectFit: "cover" }}
                                                        onClick={() =>
                                                            setImagePreview({
                                                                show: true,
                                                                url: docData[item.key].url
                                                            })
                                                        }
                                                    />
                                                ) : (
                                                    <i className="fas fa-file-pdf text-danger fa-4x mb-2"></i>
                                                )}

                                                {/* Download Button */}
                                                <a
                                                    className="btn btn-sm btn-primary w-100"
                                                    href={docData[item.key].url}
                                                    download={docData[item.key].original_filename}
                                                    target="_blank"
                                                >
                                                    <i className="fas fa-download me-1"></i>
                                                    Download
                                                </a>
                                            </div>
                                        </div>
                                    ) : null
                                )}

                                {/* Other Documents List */}
                                {Array.isArray(docData.others) &&
                                    docData.others.map((file, idx) => (
                                        <div className="col-md-4" key={idx}>
                                            <div className="border rounded p-3 shadow-sm text-center">

                                                <h6 className="fw-bold mb-2">Other Document {idx + 1}</h6>

                                                {file.original_filename.match(/\.(jpeg|jpg|png|webp)$/i) ? (
                                                    <img
                                                        src={file.url}
                                                        alt="Other File"
                                                        className="img-fluid rounded mb-3 cursor-pointer"
                                                        style={{ maxHeight: "160px", objectFit: "cover" }}
                                                        onClick={() =>
                                                            setImagePreview({
                                                                show: true,
                                                                url: file.url
                                                            })
                                                        }
                                                    />
                                                ) : (
                                                    <i className="fas fa-file-pdf text-danger fa-4x mb-2"></i>
                                                )}

                                                <a
                                                    className="btn btn-sm btn-primary w-100"
                                                    href={file.url}
                                                    download={file.original_filename}
                                                    target="_blank"
                                                >
                                                    <i className="fas fa-download me-1"></i>
                                                    Download
                                                </a>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        ) : (
                            <h4 className="text-center text-muted">No documents available</h4>
                        )}
                    </Modal.Body>

                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={() => setDocModal(false)}>
                            Close
                        </button>
                    </Modal.Footer>
                </Modal>

                <Modal
                    show={imagePreview.show}
                    onHide={() => setImagePreview({ show: false, url: "" })}
                    centered
                    size="lg"
                    dialogClassName="image-preview-modal"
                >
                    <Modal.Body className="text-center p-0">
                        {imagePreview.url && (
                            <img
                                src={imagePreview.url}
                                className="img-fluid rounded"
                                style={{ maxHeight: "90vh", objectFit: "contain" }}
                            />
                        )}

                    </Modal.Body>
                </Modal>
                <style jsx>{`
                    .cursor-pointer {
                        cursor: pointer;
                    }

                    .image-preview-modal .modal-content {
                        background: rgba(0,0,0,0.85);
                        border: none;
                        text-align: center;
                    }
                `}</style>
            </div>
        </>
    );
}
export default EcommerceDeliveryPartner;